import script from "./products.vue?vue&type=script&setup=true&lang=js"
export * from "./products.vue?vue&type=script&setup=true&lang=js"

import "./products.vue?vue&type=style&index=0&id=043f9b6b&lang=css"

const __exports__ = script;

export default __exports__